import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6b79230"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "q-pa-md" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-bottom":"15px"} }
const _hoisted_7 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Editeaza decont", -1))
const _hoisted_9 = {
  class: "text__title--medium",
  style: {"paddingLeft":"50px"}
}
const _hoisted_10 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_11 = { style: {"width":"65%","display":"flex","flex-direction":"row"} }
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column","width":"100%"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Ordin de deplasare: ", -1))
const _hoisted_14 = { class: "col-9 form__label__black" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Detalii: ", -1))
const _hoisted_16 = { class: "col-9 form__label__black" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Perioada: ", -1))
const _hoisted_18 = {
  key: 0,
  class: "col-9 form__label__black row"
}
const _hoisted_19 = { class: "columns" }
const _hoisted_20 = { class: "columns" }
const _hoisted_21 = { style: {"margin-left":"10px"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Tip deplasare: ", -1))
const _hoisted_23 = { class: "col-9 form__label__black" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Locatie: ", -1))
const _hoisted_25 = { class: "col-9 form__label__black" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Mijloc de transport: ", -1))
const _hoisted_27 = { class: "col-9 form__label__black" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 form__label" }, "Descriere: ", -1))
const _hoisted_29 = { class: "col-9 form__label__black" }
const _hoisted_30 = {
  key: 1,
  class: "form__label__black"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 text__title--medium" }, "Valoare totala decont: ", -1))
const _hoisted_32 = { class: "col-9 text__title--medium row" }
const _hoisted_33 = { class: "columns" }
const _hoisted_34 = { style: {"color":"#2f6cb7"} }
const _hoisted_35 = { class: "columns" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--medium",
  style: {"margin-left":"80px"}
}, " Stare decont:  ", -1))
const _hoisted_37 = { style: {"width":"35%","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"} }
const _hoisted_38 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_39 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente atasate", -1))
const _hoisted_41 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_44 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_48 = { class: "mobile-only" }
const _hoisted_49 = {
  clas: "row",
  style: {"margin-top":"15px"}
}
const _hoisted_50 = { class: "q-pa-xs" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Bonuri fiscale / facturi", -1))
const _hoisted_52 = {
  style: {"max-width":"30vw"},
  class: "container--span__file_scan"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons rotated90" }, "attachment", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Editare bonul fiscal / factura", -1))
const _hoisted_55 = {
  key: 0,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_57 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}
const _hoisted_58 = {
  key: 0,
  class: "row absolute-bottom-right q-pa-sm",
  style: {"margin-right":"30px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditDecontDet = _resolveComponent("EditDecontDet")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_form = _resolveComponent("q-form")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_form, { ref: "myForm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", {
                          class: _normalizeClass({
                                    column: _ctx.$q.platform.is.mobile,
                                    row: _ctx.$q.platform.is.desktop,
                                    })
                        }, [
                          _hoisted_8,
                          _createElementVNode("span", _hoisted_9, "Numar " + _toDisplayString(_ctx.decont.id_decont) + " / " + _toDisplayString(_ctx.displayData(_ctx.decont.track_date as string)), 1)
                        ], 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                        column: _ctx.$q.platform.is.mobile,
                                        row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.decont.denumire_pentru_deplasare), 1)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                            column: _ctx.$q.platform.is.mobile,
                                            row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _hoisted_15,
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.decont.detalii), 1)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                            column: _ctx.$q.platform.is.mobile,
                                            row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _hoisted_17,
                            (_ctx.decont.data_start != null && _ctx.decont.data_end != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("span", null, " Data la " + _toDisplayString(_ctx.displayData(_ctx.decont.data_start)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, " la " + _toDisplayString(_ctx.displayData(_ctx.decont.data_end)), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                            column: _ctx.$q.platform.is.mobile,
                                            row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _hoisted_22,
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.decont.tip_deplasare), 1)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                            column: _ctx.$q.platform.is.mobile,
                                            row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _hoisted_24,
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.decont.localitate), 1)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                            column: _ctx.$q.platform.is.mobile,
                                            row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _hoisted_26,
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.getDenMijlocTransport(_ctx.decont.id_mijl_transport as number)), 1)
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                            column: _ctx.$q.platform.is.mobile,
                                            row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, [
                              (_ctx.decont.stare === 'initiat')
                                ? (_openBlock(), _createBlock(_component_q_input, {
                                    key: 0,
                                    outlined: "",
                                    style: {"max-height":"12vh","max-width":"80%"},
                                    modelValue: _ctx.decont.descriere,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.decont.descriere) = $event)),
                                    type: "textarea",
                                    ref: "refDescriere",
                                    "lazy-rules": "",
                                    counter: "",
                                    maxlength: "500",
                                    rows: "3",
                                    dense: "",
                                    "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                                    rules: [ val => val && val.length > 0 || 'Completati descrierea!']
                                  }, null, 8, ["modelValue", "rules"]))
                                : _createCommentVNode("", true),
                              (_ctx.decont.stare !== 'initiat')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.decont.descriere), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                            column: _ctx.$q.platform.is.mobile,
                                            row: _ctx.$q.platform.is.desktop,
                                        }),
                            style: {"margin-top":"5px"}
                          }, [
                            _hoisted_31,
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.decont.valoare) + " RON ", 1)
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("span", {
                                  style: {"margin-left":"20px"},
                                  class: _normalizeClass(_ctx.displayStatusColor(_ctx.decont.stare as string))
                                }, _toDisplayString(_ctx.getDenStatus(_ctx.decont.stare as string)), 3)
                              ])
                            ])
                          ], 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
                                        column: _ctx.$q.platform.is.mobile,
                                        row: _ctx.$q.platform.is.desktop,
                                        })
                          }, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", null, [
                                _hoisted_40,
                                _withDirectives(_createElementVNode("div", _hoisted_41, " Nimic atasat ", 512), [
                                  [_vShow, 
                                                    _ctx.decont.scan_documents != null &&
                                                    _ctx.decont.scan_documents.length == 0 &&
                                                    !_ctx.uploadingFileToServer
                                                ]
                                ])
                              ]),
                              (_ctx.user.auth_for_upload_scan == 'y')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    (_ctx.decont.stare === 'initiat')
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 0,
                                          flat: "",
                                          color: "primary",
                                          icon: "add_box",
                                          "no-caps": "",
                                          disable: _ctx.loadingData || !(_ctx.decont.track_user == _ctx.user.userid || _ctx.user.auth_for_operatiunihr == 'y'),
                                          onClick: _ctx.openFormUploadFile
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_tooltip, {
                                              "transition-show": "rotate",
                                              "transition-hide": "rotate"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Incarca document nou ")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["disable", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", null, [
                                (_ctx.uploadingFileToServer)
                                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                                      key: 0,
                                      color: "primary",
                                      size: "3em",
                                      thickness: 10
                                    }))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_44, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.decont.scan_documents, (scan) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: scan.appid
                                          }, [
                                            (_ctx.user.is_admin == 'y' || _ctx.user.auth_for_operatiunihr == 'y' || _ctx.decont.track_user == _ctx.user.userid)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                                                  _createElementVNode("span", {
                                                    class: "material-icons cursor-pointer",
                                                    style: {"color":"red","font-size":"1.3rem"},
                                                    onClick: ($event: any) => (_ctx.askIfRemoveScan(scan))
                                                  }, "delete_forever", 8, _hoisted_46)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("td", null, _toDisplayString(scan.file_ext), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.file_size)), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_47, _toDisplayString(scan.description), 1),
                                              _createElementVNode("div", _hoisted_48, _toDisplayString(scan.description), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_btn, {
                                                round: "",
                                                color: "black",
                                                icon: "cloud_download",
                                                size: "xs"
                                              }),
                                              _createVNode(_component_q_menu, {
                                                fit: "",
                                                "transition-show": "scale",
                                                "transition-hide": "scale"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DialogOpenScan, {
                                                    appid: scan.appid,
                                                    type_scan: "Decont"
                                                  }, null, 8, ["appid"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                              ])
                            ])
                          ], 2)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_q_table, {
                        dense: "",
                        "rows-per-page-options": [0],
                        rows: _ctx.tableDataDecontDet,
                        columns: _ctx.decontDetColumns,
                        "visible-columns": _ctx.decont.stare === 'initiat' ? _ctx.visibleDecontDetColumns : _ctx.visibleDecontDetColumnsNotAction,
                        "row-key": "appid",
                        filter: _ctx.filterDecontDet,
                        loading: _ctx.loadingData,
                        pagination: _ctx.myPagination
                      }, {
                        top: _withCtx(() => [
                          _hoisted_51,
                          (_ctx.decont.stare === 'initiat')
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                flat: "",
                                color: "primary",
                                icon: "add_box",
                                "no-caps": "",
                                size: "lg",
                                disable: _ctx.loadingData || !(_ctx.decont.track_user == _ctx.user.userid || _ctx.user.auth_for_operatiunihr == 'y'),
                                onClick: _ctx.addRowDecontDet
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tooltip, {
                                    "transition-show": "rotate",
                                    "transition-hide": "rotate"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Adauga bonuri fiscale / facturi ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disable", "onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_input, {
                            dense: "",
                            debounce: "300",
                            color: "primary",
                            modelValue: _ctx.filterDecontDet,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterDecontDet) = $event))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_q_icon, { name: "search" })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        body: _withCtx((props) => [
                          _createVNode(_component_q_tr, { props: props }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_td, {
                                key: "nr_document",
                                props: props,
                                sortable: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.nr_document), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "data",
                                props: props,
                                sortable: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.displayData(props.row.data)), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "descriere",
                                props: props,
                                style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.descriere), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "denumire_cont",
                                props: props,
                                sortable: true,
                                style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.denumire_cont), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "valoare",
                                props: props,
                                sortable: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.valoare), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "nume_furnizor",
                                props: props,
                                sortable: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.nume_furnizor), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "angajat",
                                props: props,
                                sortable: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.angajat), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "atasament",
                                props: props,
                                style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_52, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.scan_documents_det, (scan) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: scan.appid,
                                        class: "cursor-pointer span__file_scan"
                                      }, [
                                        _hoisted_53,
                                        _createTextVNode(" " + _toDisplayString(_ctx.humanReadableBytes(scan.file_size)) + "." + _toDisplayString(scan.file_ext) + " ", 1),
                                        _createVNode(_component_q_menu, {
                                          fit: "",
                                          "transition-show": "scale",
                                          "transition-hide": "scale"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DialogOpenScan, {
                                              appid: scan.appid,
                                              type_scan: "Decont"
                                            }, null, 8, ["appid"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              ((_ctx.decont.stare === 'initiat' && _ctx.decont.track_user == _ctx.user.userid) || _ctx.user.auth_for_operatiunihr == 'y')
                                ? (_openBlock(), _createBlock(_component_q_td, {
                                    key: "appid",
                                    props: props
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        name: "edit",
                                        class: "text-blue cursor-pointer",
                                        style: {"font-size":"1.2rem","margin-left":"auto","margin-right":"5px"},
                                        onClick: ($event: any) => (_ctx.askIfEditThisDecontDet(props.row))
                                      }, null, 8, ["onClick"]),
                                      _createVNode(_component_q_icon, {
                                        name: "delete_forever",
                                        class: "text-red cursor-pointer",
                                        style: {"font-size":"1.3rem","margin-left":"auto"},
                                        onClick: ($event: any) => (_ctx.askIfDeleteDecontDetThis(props.row))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1032, ["props"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["props"])
                        ]),
                        _: 1
                      }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]),
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.visibleDialogEditDecontDet,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visibleDialogEditDecontDet) = $event)),
                        persistent: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_bar, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, { name: "add_box" }),
                                  _hoisted_54,
                                  _createVNode(_component_q_space),
                                  _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                    dense: "",
                                    flat: "",
                                    icon: "close",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshDataTableDeconturiDet(false)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Close")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })), [
                                    [_directive_close_popup]
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_EditDecontDet, {
                                    foncancel: _ctx.renuntEditareDecontDet,
                                    fonsave: _ctx.refreshDataTableDeconturiDet,
                                    appid: _ctx.appidDecontDet,
                                    currentRowViewDecont: _ctx.decont
                                  }, null, 8, ["foncancel", "fonsave", "appid", "currentRowViewDecont"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  (_ctx.decont.stare !== 'initiat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createVNode(_component_TaskList, {
                          appid: _ctx.appid,
                          task: _ctx.task,
                          onState: _ctx.onState,
                          isSuccess: _ctx.isSuccess
                        }, null, 8, ["appid", "task", "onState", "isSuccess"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_q_dialog, {
                modelValue: _ctx.dialogUploadFile,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
                position: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card, { style: {"width":"350px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_linear_progress, {
                        value: 0.6,
                        color: "pink"
                      }),
                      _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
                        default: _withCtx(() => [
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_q_input, {
                              counter: "",
                              outlined: "",
                              modelValue: _ctx.uploadScanTitle,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                              label: "Titlu document (minim 4 caractere)",
                              dense: "",
                              maxlength: "200"
                            }, null, 8, ["modelValue"])
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "file",
                            name: "fileToUpload",
                            id: "fileToUpload",
                            ref: "myFileToUpload",
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.prepareForUpload($event))),
                            style: {"margin-bottom":"10px"}
                          }, null, 544), [
                            [_vShow, _ctx.uploadScanTitle.length>3]
                          ]),
                          _withDirectives(_createVNode(_component_q_btn, {
                            disable: !(_ctx.uploadScanTitle.length>3),
                            icon: "cloud_upload",
                            color: "white",
                            "text-color": "black",
                            label: "Salveaza pe server",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploadFile())),
                            loading: _ctx.uploadingFileToServer,
                            style: {"margin-bottom":"5px"}
                          }, null, 8, ["disable", "loading"]), [
                            [_vShow, _ctx.checkIfFileIsSelected]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 512),
          (_ctx.decont.stare === 'initiat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createVNode(_component_q_btn, {
                  label: "Salveaza",
                  type: "submit",
                  color: "primary",
                  onClick: _ctx.onSave,
                  style: {"margin-left":"5px"},
                  size: "sm",
                  disable: !(_ctx.decont.track_user == _ctx.user.userid || _ctx.user.auth_for_operatiunihr == 'y')
                }, null, 8, ["onClick", "disable"]),
                ((_ctx.decont.appid != 0 && _ctx.decont.stare === 'initiat'))
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      label: "TRIMITE PE FLUX",
                      color: "green",
                      onClick: _ctx.onSendApproved,
                      style: {"margin-left":"5px"},
                      size: "sm",
                      disable: !(_ctx.decont.track_user == _ctx.user.userid || _ctx.user.auth_for_operatiunihr == 'y')
                    }, null, 8, ["onClick", "disable"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_btn, {
                  label: "Renunt",
                  size: "sm",
                  type: "reset",
                  flat: "",
                  onClick: _ctx.onCancel,
                  style: {"margin-left":"5px"}
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}